// Phase 9 — perf polish
// (5) Debounce add-to-cart submissions: prevent rapid double-click from
//     submitting the same form twice (which would cause line-quantity x2 on
//     the same product, or race the cart-notification).
// (6) Prefetch product pages on card hover: when user hovers a product link
//     for >120ms, inject <link rel="prefetch"> so the page HTML is in the
//     browser cache by the time they click. Click feels instant.
(function () {
  'use strict';

  /* ---------- (5) Debounce add-to-cart + INSTANT tap success flash ---------- */
  let lastAddBtn = null;
  /* Optimistic UI — instant feedback before server response:
     - ✓ flash on the + button
     - Cart badge count +1 (and total +product price if known)
     - Cart drawer auto-opens */
  let autoCloseTimer = null;
  const AUTO_CLOSE_MS = 2000;

  function closeCartDrawer() {
    const dropdown = document.getElementById('cart-icon-bubble');
    const drawer = dropdown && dropdown.querySelector('.dropdown-menu');
    const toggle = document.getElementById('toggleCountCart');
    if (dropdown) dropdown.classList.remove('show');
    if (drawer) drawer.classList.remove('show');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
  function scheduleAutoClose() {
    if (autoCloseTimer) clearTimeout(autoCloseTimer);
    autoCloseTimer = setTimeout(closeCartDrawer, AUTO_CLOSE_MS);
  }
  function cancelAutoClose() {
    if (autoCloseTimer) { clearTimeout(autoCloseTimer); autoCloseTimer = null; }
  }
  function openCartDrawer() {
    const dropdown = document.getElementById('cart-icon-bubble');
    const drawer = dropdown && dropdown.querySelector('.dropdown-menu');
    const toggle = document.getElementById('toggleCountCart');
    if (dropdown) dropdown.classList.add('show');
    if (drawer) drawer.classList.add('show');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    scheduleAutoClose();
  }

  /* Drawer hover/touch interaction → cancel/reschedule auto-close */
  document.addEventListener('mouseover', function (e) {
    const inDrawer = e.target.closest && e.target.closest('#cart-icon-bubble .dropdown-menu');
    if (inDrawer) cancelAutoClose();
  });
  document.addEventListener('mouseout', function (e) {
    const inDrawer = e.target.closest && e.target.closest('#cart-icon-bubble .dropdown-menu');
    const toRelated = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('#cart-icon-bubble .dropdown-menu');
    /* Only reschedule when leaving the drawer entirely (not moving between children) */
    if (inDrawer && !toRelated) scheduleAutoClose();
  });
  /* Mobile: any tap inside drawer = user is interacting → reset timer */
  document.addEventListener('touchstart', function (e) {
    const inDrawer = e.target.closest && e.target.closest('#cart-icon-bubble .dropdown-menu');
    if (inDrawer) {
      cancelAutoClose();
      /* Reschedule from the moment of touch — gives 3s after they stop tapping */
      setTimeout(scheduleAutoClose, 0);
    }
  }, { passive: true });
  function getCardPriceCents(btn) {
    const card = btn.closest('.wbproduct-container');
    if (!card) return 0;
    const priceEl = card.querySelector('.price-item--sale, .price-item--regular, .wbhprice');
    if (!priceEl) return 0;
    const text = (priceEl.textContent || '').replace(/,/g, '');
    const m = text.match(/\$?(\d+\.?\d*)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  }

  /* Clear placeholders when the real refresh lands (cart:updated WITHOUT detail
     is dispatched by cart-notification.js + wbcartdropdown.js after server replies).
     Then move the just-added item to the top of the drawer so the customer sees it. */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail) return; // optimistic — don't clear
    document.querySelectorAll('.ae-optimistic-item').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    /* Bring the just-added item to the top of the drawer */
    if (window.AE_LAST_ADDED_HANDLE) {
      const list = document.querySelector('#cart-icon-bubble #webi-main-cart-items .js-contents');
      if (list) {
        const items = list.querySelectorAll('.wbheadcartdrop:not(.ae-optimistic-item)');
        for (const item of items) {
          const link = item.querySelector('a[href*="/products/"]');
          if (link) {
            const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
            const h = m ? m[1] : '';
            if (h === window.AE_LAST_ADDED_HANDLE && item !== list.firstElementChild) {
              list.insertBefore(item, list.firstElementChild);
              break;
            }
          }
        }
      }
    }
  });

  function insertOptimisticItem(btn) {
    const card = btn.closest('.wbproduct-container');
    if (!card) return;
    const img = card.querySelector('img');
    const titleEl = card.querySelector('.product-title a, .wbcrtname, [class*="product-title"] a');
    const priceEl = card.querySelector('.price-item--sale, .price-item--regular');
    const linkEl = card.querySelector('a[href*="/products/"]');
    if (!img || !titleEl) return;

    const list = document.querySelector('#cart-icon-bubble #webi-main-cart-items .js-contents');
    if (!list) return;

    const imgSrc = img.src || img.getAttribute('data-src') || '';
    const title = (titleEl.textContent || '').trim();
    const price = ((priceEl && priceEl.textContent) || '').trim();
    const url = linkEl ? linkEl.getAttribute('href') : '#';
    const priceCents = getCardPriceCents(btn);
    /* Extract product handle (slug between /products/ and ? or #) for matching */
    function handleOf(u) {
      const m = (u || '').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : '';
    }
    const cardHandle = handleOf(url);

    /* If a real cart line for the same product already exists, bump its qty +1
       and its line-total — no placeholder needed. Also move it to the top of
       the drawer so customer sees it. */
    function bumpExistingLine(itemEl) {
      const qtyInput = itemEl.querySelector('.quantity__input, input[name="updates[]"]');
      if (qtyInput) {
        const cur = parseInt(qtyInput.value || qtyInput.getAttribute('value') || '0', 10) || 0;
        qtyInput.value = String(cur + 1);
        qtyInput.setAttribute('value', String(cur + 1));
      }
      const totalEl = itemEl.querySelector('.cart-item__totals .price, .price--end');
      if (totalEl && priceCents > 0) {
        const cur = parseInt(qtyInput && qtyInput.value, 10) || 1;
        const newTotal = priceCents * cur;
        totalEl.textContent = '$' + (newTotal / 100).toFixed(2);
      }
      /* Move to top of the items list (instant — no waiting for server) */
      if (itemEl.parentNode && itemEl !== itemEl.parentNode.firstElementChild) {
        itemEl.parentNode.insertBefore(itemEl, itemEl.parentNode.firstElementChild);
      }
    }

    /* 1. Existing optimistic placeholder for same handle → bump qty + total */
    const placeholders = list.querySelectorAll('.ae-optimistic-item');
    for (const p of placeholders) {
      if (handleOf(p.dataset.handle) === cardHandle) {
        bumpExistingLine(p);
        return;
      }
    }

    /* 2. Existing real cart line for same product → bump it instantly */
    const realItems = list.querySelectorAll('.wbheadcartdrop:not(.ae-optimistic-item)');
    for (const itemEl of realItems) {
      const link = itemEl.querySelector('a[href*="/products/"]');
      if (link && handleOf(link.getAttribute('href')) === cardHandle) {
        bumpExistingLine(itemEl);
        return;
      }
    }

    const item = document.createElement('div');
    item.className = 'wbheadcartdrop ae-optimistic-item';
    item.dataset.handle = url;
    item.innerHTML =
      '<div class="wbcartdimg">' +
        '<a href="' + url + '"><img src="' + imgSrc + '" alt="" loading="lazy" width="100" height="100" style="object-fit:contain"></a>' +
      '</div>' +
      '<div class="wbcartddesc">' +
        '<a href="' + url + '" class="wbcrtname">' + title + '</a>' +
        '<div class="wbcartqtybr">' +
          '<webi-quantity-input class="quantity">' +
            '<button class="quantity__button" name="minus" type="button" disabled>−</button>' +
            '<input class="quantity__input" type="number" value="1" min="0" disabled>' +
            '<button class="quantity__button" name="plus" type="button" disabled>+</button>' +
          '</webi-quantity-input>' +
          '<div class="cart-item__totals"><span class="price price--end">' + price + '</span></div>' +
        '</div>' +
      '</div>';
    list.insertBefore(item, list.firstChild);

    /* If the empty-cart state ("Your cart is empty") is showing, hide it */
    const empty = document.querySelector('#cart-icon-bubble .cart__empty-text');
    if (empty) empty.style.display = 'none';

    /* Auto-cleanup: if for some reason the server response doesn't replace the
       items list within 6s (e.g., add fails), remove the placeholder so it
       doesn't linger. */
    setTimeout(function () {
      if (item.parentNode) item.parentNode.removeChild(item);
    }, 6000);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('.card__quick-add');
    if (!btn) return;
    lastAddBtn = btn;
    /* Instant visual feedback */
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 900);
    /* BUG-C (2026-05-29): badge + total are now both written from
       mini-cart-popup.queueAdd's success handler in the same syncCountAndState
       call once /cart/add.js confirms the add. Earlier, perf-instant wrote
       CartTotalText optimistically and dispatched cart:updated{total} on
       click, which triggered mini-cart-popup's listener to refreshFromServer
       → fetch /cart.js → see the empty pre-add cart → write CartTotalText
       back to $0.00. The total oscillated $0 ↔ $2.99 six times in 750ms on
       a single click. Dropping both the textContent write and the dispatch
       removes the premature path; the optimistic placeholder line + drawer
       open are kept, and free-shipping-bar's own fetch interception refreshes
       it ~80ms after the /cart/add.js response. */
    /* Track which product was just added so we can move it to top after refresh */
    const card = btn.closest('.wbproduct-container');
    const cardLink = card && card.querySelector('a[href*="/products/"]');
    if (cardLink) {
      const m = (cardLink.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      window.AE_LAST_ADDED_HANDLE = m ? m[1] : '';
    }
    /* Insert visual placeholder of the added product in cart drawer instantly */
    insertOptimisticItem(btn);
    setTimeout(openCartDrawer, 250);
  }, true);

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    if (form.dataset.aeSubmitting === '1') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    form.dataset.aeSubmitting = '1';
    /* DO NOT disable the button �� that breaks the optimistic ✓ animation.
       Debounce by submitting flag only. */
    const reset = function () { form.dataset.aeSubmitting = ''; };
    setTimeout(reset, 1500);
    document.addEventListener('cart:updated', reset, { once: true });
  }, true);

  /* ---------- (7) Carousel swipe-hint animation ----------
     On first viewport entry, briefly slides the carousel right then back so
     customers discover horizontal swipe (replaces hidden prev/next arrows). */
  function hintCarousel(carousel) {
    /* Skip slideshow (.owl-slider for hero banner) — only product carousels */
    if (carousel.classList.contains('owl-slider')) return;

    /* Method 1: jQuery slick API */
    if (window.jQuery) {
      const $ = window.jQuery;
      const $c = $(carousel);
      if ($c.hasClass('slick-initialized')) {
        $c.slick('slickNext');
        setTimeout(function () { $c.slick('slickPrev'); }, 700);
        return;
      }
      if ($c.hasClass('owl-loaded')) {
        $c.trigger('next.owl.carousel', [500]);
        setTimeout(function () { $c.trigger('prev.owl.carousel', [500]); }, 700);
        return;
      }
    }
    /* Method 2: click the (hidden) arrow buttons — JS click() works on display:none */
    const next = carousel.querySelector('.slick-next, .owl-next');
    const prev = carousel.querySelector('.slick-prev, .owl-prev');
    if (next) {
      next.click();
      setTimeout(function () { if (prev) prev.click(); }, 700);
    }
  }

  function bindCarouselHints() {
    if (!('IntersectionObserver' in window)) return;
    const carousels = document.querySelectorAll('.slick-slider, .owl-carousel, .wbproduct-slider');
    if (!carousels.length) return;
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.swipeHinted) {
          entry.target.dataset.swipeHinted = '1';
          /* Slight delay so carousel finishes init + page settles */
          setTimeout(function () { hintCarousel(entry.target); }, 350);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.45 });
    carousels.forEach(function (c) { observer.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      /* Wait additional 600ms for Slick/Owl to fully init across all sections */
      setTimeout(bindCarouselHints, 600);
    });
  } else {
    setTimeout(bindCarouselHints, 600);
  }

  /* ---------- (6) Prefetch on hover — covers products, collections, blogs, pages ----------
     When the user hovers a link for ~65ms (or touches it), we inject <link rel="prefetch">
     so the page HTML is in the browser cache by the time they click. Click feels instant. */
  const prefetched = new Set();
  function prefetch(url) {
    if (prefetched.has(url)) return;
    prefetched.add(url);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }
  /* Match any internal navigation worth pre-loading. Excludes cart/checkout/account
     (sensitive, dynamic) and external URLs. */
  const PREFETCH_PATTERN = /\/(products|collections|blogs|pages)\/[a-z0-9\-_%]/i;
  function isPrefetchable(href) {
    if (!href) return false;
    if (href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return false;
    return PREFETCH_PATTERN.test(href);
  }
  let hoverTimer = null;
  let hoverLink = null;
  function onEnter(e) {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (!isPrefetchable(href)) return;
    if (a.href === hoverLink) return;
    hoverLink = a.href;
    clearTimeout(hoverTimer);
    /* 65ms — short enough that even quick clicks trigger preload, long enough
       to skip accidental hovers during scroll. */
    hoverTimer = setTimeout(function () { prefetch(hoverLink); }, 65);
  }
  function onLeave() {
    clearTimeout(hoverTimer);
    hoverLink = null;
  }
  document.addEventListener('mouseover', onEnter, { passive: true });
  document.addEventListener('mouseout', onLeave, { passive: true });
  /* Touch devices: prefetch on touchstart — runs ~100-300ms before tap fires,
     so by the time the click registers the HTML is already in cache. */
  document.addEventListener('touchstart', function (e) {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (isPrefetchable(href)) prefetch(a.href);
  }, { passive: true });

  /* ---------- (8) Speculation Rules API — modern Chromium browsers prerender
     (full load + JS execute) on intent signals. Truly instant navigation when supported. */
  if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    const rules = document.createElement('script');
    rules.type = 'speculationrules';
    /* Conservative: prerender only on click intent (not hover). Scope limited to product/collection/blog paths.
       Earlier "moderate + /*" was too aggressive — caused 3-4s post-load lag from prerendering many pages
       in parallel. Conservative trades a tiny bit of nav speed for much smoother initial page load. */
    rules.textContent = JSON.stringify({
      prerender: [{
        where: {
          or: [
            { href_matches: '/products/*' },
            { href_matches: '/collections/*' },
            { href_matches: '/blogs/*' }
          ]
        },
        eagerness: 'conservative'
      }]
    });
    document.head.appendChild(rules);
  }
})();
